import http from './api'
import Vue from 'vue'
export default{
  // 上传文件
  uploadFile(params){
    return http.postForm(Vue,'/xxx-cms/file/upload',params)
  },
  // 上传图片
  uploadImage(params){
    return http.postForm(Vue,'/xxx-cms/image/upload',params)
  },
  // 携带章程图片上传（批量）
  uploadByRulesImage(params){
    return http.postForm(Vue,'/xxx-game/image/batch/uploadByRules',params)
  },
  // 获取验证码
  getVerifyCode(params){
    return http.postJson(Vue,'/xxx-user/code/send', params)
  },
  // 字典表
  getDictData(params){
    return http.get(Vue,'/user/sysDictKey/dictData',params)
  },
  // 客服聊天
  getChat(params){
    return http.postJson(Vue,'/chat/msg/sendMsg',params)
  },
  // 路由导航
  getNav(params){
    return http.get(Vue,'/xxx-cms/pc/homePage/nav',params)
  },
  // 省市区
  getFull(params){
    return http.get(Vue,'/xxx-cms/districts/full',params)
  },
  // 省市
  getSimple(params){
    return http.get(Vue,'/xxx-cms/districts/simple',params)
  },
  // 收款账户
  getReceiveAccount(params){
    return http.get(Vue,'/xxx-cms/pc/receiveAccount/list',params)
  },
  // 搜一搜
  getSearch(params){
    return http.get(Vue,'/xxx-cms/pc/homePage/search',params)
  },
  // 安卓下载包
  getAndroid(params){
    return http.get(Vue,'/xxx-cms/pc/download/android',params)
  },
  // IOS下载包
  getIos(params){
    return http.get(Vue,'/xxx-cms/pc/download/ios',params)
  },
  // 补缴凭证
  // 列表
  getSupPayCertList(params){
    return http.get(Vue,'/xxx-cms/pc/supPayCert/list',params)
  },
  // 信息
  getSupPayCertInfo(params){
    return http.get(Vue,'/xxx-cms/pc/supPayCert/baseInfo',params)
  },
  // 提交
  postSupPayCertSubmit(params){
    return http.postJson(Vue,'/xxx-cms/pc/supPayCert/submit',params)
  },
  // 招聘模块
  // 岗位详情
  getRecruitmentInfo(params){
    return http.get(Vue,'/xxx-cms/recruitment/info',params)
  },
  // 岗位列表
  getRecruitmentList(params){
    return http.get(Vue,'/xxx-cms/recruitment/list',params)
  },
  // 提交 
  postRecruitmentSubmit(params){
    return http.postJson(Vue,'/xxx-cms/recruitment/submit',params)
  },
  // 省市区
  getRecruitmentDistricts(params){
    return http.get(Vue,'/xxx-cms/recruitment/districts',params)
  },
}


// WEBPACK FOOTER //
// ./src/api/common.js